export default __webpack_public_path__ + "68c678384b2cc1ef12c59ee76c779efa.png";